import app from '@devices/settings/device_settings/app.js';
import internet from '@devices/settings/device_settings/internet.js';
import share from '@devices/settings/device_settings/share.js';

export default {
	name: 'shellyspot',
	friendly_name: 'Spot',
	family: 'sensor',
	isPM: false,
	modes: {
		sensor: {
			availableViews: ['basic', 'advanced'],
			control_holder: -1,
			channels: 1,
			settings: [
				{
					title: 'sensor_settings',
					components: [
						{
							title: 'illumination_definitions',
							component: 'illumination_definitions',
						},
						{ title: 'light_duration', component: 'light_duration' },
					],
				},
				app,
				internet,
				share,
				{
					title: 'settings',
					components: [
						{ title: 'firmware_version', component: 'firmware_update' },
						{
							title: 'geo_location_and_time_zone',
							component: 'geo_location_and_time_zone',
						},
						{ title: 'device_name', component: 'device_name' },
						{ title: 'channel_name', component: 'channel_name' },
						{ title: 'factory_reset', component: 'factory_reset_g1' },
						{ title: 'device_information', component: 'device_information' },
					],
				},
			],
		},
	},
};
